import { lazy } from 'react';
import { Navigate } from 'react-router-dom';

// project imports
import Loadable from 'components/Loadable';
import DashboardLayout from 'layout/Dashboard';

// render- Dashboard
const DashboardDefault = Loadable(lazy(() => import('pages/dashboard/CoreAdminDashboard')));

// render - Generation analytics
const GenerationAnalyticsPage = Loadable(lazy(() => import('pages/generation-analytics/GenerationAnalyticsPage')));
const SchedulerMlPage = Loadable(lazy(() => import('pages/scheduler-ml/SchedulerMlPage')));
const GenerationQueuePrioritiesPage = Loadable(lazy(() => import('pages/generation-queue/GenerationQueuePrioritiesPage')));

// render - Clones
const ClonesList = Loadable(lazy(() => import('pages/clones/ClonesList')));
const CloneForm = Loadable(lazy(() => import('pages/clones/CloneForm')));
const CloneAttributes = Loadable(lazy(() => import('pages/clones/CloneAttributes')));

// render - Attributes
const AttributesManagement = Loadable(lazy(() => import('pages/attributes/AttributesManagement')));

// render - Modules
const ModulesManagement = Loadable(lazy(() => import('pages/modules/ModulesManagement')));

// render - Tariffs
const TariffsManagement = Loadable(lazy(() => import('pages/tariffs/TariffsManagement')));

// render - Notifications
const NotificationsList = Loadable(lazy(() => import('pages/notifications/NotificationsList')));
const EmailPreviewSamples = Loadable(lazy(() => import('pages/notifications/EmailPreviewSamples')));
const BillingEventsList = Loadable(lazy(() => import('pages/billing-events/BillingEventsList')));
const PaymentsList = Loadable(lazy(() => import('pages/payments/PaymentsList')));

// render - color
const Color = Loadable(lazy(() => import('pages/component-overview/color')));
const Typography = Loadable(lazy(() => import('pages/component-overview/typography')));
const Shadow = Loadable(lazy(() => import('pages/component-overview/shadows')));

// render - sample page
const SamplePage = Loadable(lazy(() => import('pages/extra-pages/sample-page')));

// ==============================|| MAIN ROUTING ||============================== //

const MainRoutes = {
  path: '/',
  element: <DashboardLayout />,
  children: [
    {
      index: true,
      element: <Navigate to="/clones" replace />
    },
    {
      path: 'dashboard',
      children: [
        {
          path: 'default',
          element: <DashboardDefault />
        }
      ]
    },
    {
      path: 'typography',
      element: <Typography />
    },
    {
      path: 'color',
      element: <Color />
    },
    {
      path: 'shadow',
      element: <Shadow />
    },
    {
      path: 'sample-page',
      element: <SamplePage />
    },
    {
      path: 'clones',
      children: [
        {
          path: '',
          element: <ClonesList />
        },
        {
          path: 'create',
          element: <CloneForm />
        },
        {
          path: 'edit/:id',
          element: <CloneForm />
        },
        {
          path: ':id/attributes',
          element: <CloneAttributes />
        }
      ]
    },
    {
      path: 'generation-analytics',
      element: <GenerationAnalyticsPage />
    },
    {
      path: 'scheduler-ml',
      element: <SchedulerMlPage />
    },
    {
      path: 'generation-queue-priorities',
      element: <GenerationQueuePrioritiesPage />
    },
    {
      path: 'modules',
      children: [
        {
          path: '',
          element: <ModulesManagement />
        },
        {
          path: 'create',
          element: <ModulesManagement />
        }
      ]
    },
    {
      path: 'tariffs',
      element: <TariffsManagement />
    },
    {
      path: 'notifications',
      element: <NotificationsList />
    },
    {
      path: 'email-previews',
      element: <EmailPreviewSamples />
    },
    {
      path: 'billing-events',
      element: <BillingEventsList />
    },
    {
      path: 'payments',
      element: <PaymentsList />
    },
    {
      path: 'attributes',
      element: <AttributesManagement />
    }
  ]
};

export default MainRoutes;
